import ListFilter from 'Shared/components/list-filter';
import addDays from 'date-fns/addDays';
import isAfter from 'date-fns/isAfter';
import isWithinInterval from 'date-fns/isWithinInterval';
import parseISO from 'date-fns/parseISO';


export const ALL = 'ALL';
export const SOLD = 'SOLD';
export const MONITORED = 'MONITORED';
export const OVERDUE = 'OVERDUE';

const stateFilter = (invoice, { state }) => {
  switch (state) {
    case SOLD:
      return invoice.serviceId !== 2;
    case MONITORED:
      return invoice.serviceId === 2;
    case OVERDUE: {
      const now = parseISO(invoice.referenceDate);
      const due = parseISO(invoice.dueDate);
      return !invoice.payed
        && isAfter(now, addDays(due, 1));
    }
    case ALL:
    default:
      return true;
  }
};

const minDate = new Date(1, 0, 1);
const maxDate = new Date(9999, 0, 1);

const invoiceDateFilter = (invoice, { filterDateBy = 'invoiceDate', fromDate, toDate }) => {
  if (isAfter((fromDate || minDate), (toDate || maxDate))) return false;

  return isWithinInterval(parseISO(invoice[filterDateBy]), {
    start: fromDate || minDate,
    end: toDate || maxDate,
  });
};

const pieChartFilter = (invoice, { pieChartLabelWithIndex }) => (pieChartLabelWithIndex === null
  ? true
  : pieChartLabelWithIndex.startsWith(invoice.filterStatus)
);


const LedgerFilter = (props) => (
  <ListFilter
    {...props}
    filterActions={[
      stateFilter,
      invoiceDateFilter,
      pieChartFilter,
    ]}
  />
);

export default LedgerFilter;
